(() => {
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = (root) => {
    const track = root.querySelector('[data-case-color-track]');
    const max = track.scrollWidth - track.clientWidth;
    root.dataset.caseOverflow = String(max > 2);
    root.querySelector('[data-case-scroll="-1"]').disabled = track.scrollLeft <= 2;
    root.querySelector('[data-case-scroll="1"]').disabled = track.scrollLeft >= max - 2;
  };
  const reveal = (root) => {
    const track = root.querySelector('[data-case-color-track]');
    const selected = track.querySelector('input:checked')?.closest('.color-swatch');
    if (!selected) return;
    const bounds = track.getBoundingClientRect();
    const card = selected.getBoundingClientRect();
    const offset = card.left < bounds.left ? card.left - bounds.left - 4 : card.right > bounds.right ? card.right - bounds.right + 4 : 0;
    if (offset) track.scrollBy({left:offset,behavior:'instant'});
  };
  const initialize = () => {
    document.querySelectorAll('[data-case-color-carousel]').forEach((root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const track = root.querySelector('[data-case-color-track]');
      root.querySelectorAll('[data-case-scroll]').forEach((button) => button.addEventListener('click', () => {
        if (button.disabled) return;
        const card = track.querySelector('.color-swatch');
        const gap = parseFloat(getComputedStyle(track).gap) || 12;
        track.scrollBy({left:Number(button.dataset.caseScroll) * (card.getBoundingClientRect().width + gap),behavior:reducedMotion.matches ? 'instant' : 'smooth'});
      }));
      root.addEventListener('change', () => { reveal(root); update(root); });
      track.addEventListener('scroll', () => update(root), {passive:true});
      new ResizeObserver(() => update(root)).observe(track);
      reveal(root);
      update(root);
    });
  };
  document.addEventListener('shopify:section:load', initialize);
  new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1 && (node.matches('[data-case-color-carousel]') || node.querySelector('[data-case-color-carousel]'))))) initialize();
  }).observe(document.body,{childList:true,subtree:true});
  initialize();
})();
